import request from "@/utils/request";

let apiURL = 'https://open-api.openocean.finance'

export const getRpc = async () => {
  let url = `${apiURL}/v3/solana/getRpc`
  const { data } = await request({
    url
  })
  // return data.openapi_v1[0]

  return 'https://morna-skm1k6-fast-mainnet.helius-rpc.com/'
}